import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import Paragraph from './Paragraph';

const useStyles = makeStyles((theme) => ({
  root: () => ({
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 7),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 14),
    },
  }),
}));

const Quote = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Paragraph {...props} />
    </Box>
  );
};

Quote.defaultProps = {
  bold: false,
  color: 'inherit',
  children: null,
  italic: false,
  textAlign: 'left',
  title: null,
  variant: 'body1',
};

Quote.propTypes = {
  bold: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  italic: PropTypes.bool,
  textAlign: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['body1', 'body2']),
};

export default Quote;
